/* eslint-disable */
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Glyphicon } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch, parseTimeString } from '../../utils/util';
import Highlighter from "react-highlight-words";

import OzFormComponent from './OzFormComponent';
import './SimpleEscapeForm.css';

import {
  upload,
} from '../../actions';


class MemberForm extends OzFormComponent {
  static fields = [
    'name',
    'email',
  ]

  renderBody() {
    return (
      <div className="MemberForm">
        {this.renderFormGroupPair(['Player email', 'email', 'email'],
                                  ['Name (optional)', 'text', 'name'])}
      </div>
    );
  }
}


class SimpleEscapeForm extends OzFormComponent {

  static fields = [
    'roomId',
    'didEscape',
    'time',
    'photo',
    'teamName',
    'members',
  ];


  options = {
    members: {
      init: {
        email: '',
        name: '',
      }
    },
  }

  constructor(props) {
    super(props);

    if (props.values.time && props.values.seconds) {
      let prefix = props.values.seconds < 10 ? '0' : '';
      this.state.time = props.values.time + ':' + prefix + props.values.seconds
    }
  }

  getValues() {
    let values = super.getValues();

    if (this.state.time) {
      let r = parseTimeString(this.state.time);
      values.time = r.time;
      values.seconds = r.seconds;
    }

    let escapeFields = [
      'didEscape',
      'time',
      'seconds',
      'photo',
    ];

    let teamFields = [
      'teamName',
      'members',
    ];

    let room = {};
    if (this.state.roomId) {
      room.roomId = this.state.roomId;
    }
    let escape = {};
    for (let field of escapeFields) {
      escape[field] = values[field];
    }
    let team = {};
    for (let field of teamFields) {
      team[field] = values[field];
    }
    return { room, escape, team };
  }

  renderMembers() {
    let members = this.state.members || [];
    let i = 0;
    let nodes = members.map(member => {
      let index = i;
      i++;
      return (
        <MemberForm
          key={member.id}
          index={member.id}
          errors={this.props.errors ? this.props.errors.members[index] : null}
          part={true}
          values={member}
          cancelRender={() => <Glyphicon className="minus-sign" glyph="minus-sign" />}
          onCancel={() => this.removeMany(member.id, 'members')}
          onChange={(values) => this.updateMany(member.id, values, 'members')}
        />
      );
    });

    return (
      <div className="members-wrapper">
        {nodes}
      </div>
    );
  }

  renderTeamForm() {
    return (
      <div className="team-form">
        {this.renderFormGroup('Team name', 'text', 'teamName')}
        {this.renderMembers()}
        <div className="add-member">
          <Button onClick={() => this.addMany('members')}>Add Player</Button>
          <HelpBlock>To email this escape to players, add their emails here.</HelpBlock>
        </div>
      </div>
    );
  }

  renderBody() {
    let didEscapeOptions = [
      [true, 'Yes!'],
      [false, 'No...'],
    ];

    console.log('did escape?', this.state.didEscape)

    return (
      <div className="SimpleEscapeForm">
        {this.props.enterTeam && this.renderTeamForm()}

        <div div className="did-escape">
          {this.renderFormGroup('Did the team escape?', 'pills', 'didEscape', didEscapeOptions)}
        </div>
        {this.state.didEscape && this.renderFormGroup('Time', 'text', 'time', { placeholder: 'Eg. "53:21"' })}
        {this.renderFormGroup('Photo', 'image', 'photo')}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    upload,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SimpleEscapeForm);



/** WEBPACK FOOTER **
 ** ./src/components/partials/SimpleEscapeForm.js
 **/